import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
//import CircularProgress from '@material-ui/core/CircularProgress';
import imgLoader from '../../assets/img/loader.gif'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const Loading = () => {
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open>
      {/*<CircularProgress color="inherit" />*/}
      <img src={imgLoader} alt=""/>
    </Backdrop>
  );
};
export default Loading;
